import { render, staticRenderFns } from "./specification-by-product-type.vue?vue&type=template&id=42603740&scoped=true&"
import script from "./specification-by-product-type.vue?vue&type=script&lang=js&"
export * from "./specification-by-product-type.vue?vue&type=script&lang=js&"
import style0 from "./specification-by-product-type.vue?vue&type=style&index=0&id=42603740&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42603740",
  null
  
)

export default component.exports